import { SEO } from "@/components/common/SEO";
import { PageHero } from "@/components/sections/PageHero";
import { Capabilities } from "@/components/sections/Capabilities";
import { CTABand } from "@/components/sections/CTABand";
import { CAPABILITIES } from "@/data/content";

export default function TherapeuticAreasPage() {
  return (
    <>
      <SEO
        title="Therapeutic Areas"
        description="MedCore Research matches study opportunities with site capabilities and physician interests across a broad range of therapeutic areas."
        path="/therapeutic-areas"
      />
      <PageHero
        eyebrow="Therapeutic Areas"
        title={CAPABILITIES.heading}
        description={CAPABILITIES.intro[0]}
      />
      <Capabilities withHeading={false} muted={false} />
      <CTABand title="Exploring a study in your therapeutic area?" />
    </>
  );
}
